import DynamicIcon from '../DynamicIcon'
import { Media } from '../Media'
import { Button } from '../ui/button'

import { Endorsed, TeamMember } from '@/payload-types'

interface TeamMemberCardProps {
  member: TeamMember | Endorsed
  onClick: (member: TeamMember | Endorsed) => void
}

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({ member, onClick }) => {
  return (
    <div
      className="relative mx-auto flex h-[350px] w-full cursor-pointer flex-col justify-end overflow-hidden rounded-xl bg-card xs:max-w-85 sm:max-w-none"
      onClick={() => onClick(member)}
    >
      {/* Image */}
      <div
        className="absolute inset-0 z-1 size-full rounded-xl"
        style={{ backgroundColor: 'hsl(var(--evergreen-100, 142 40% 90%))' }}
      >
        {member.image && (
          <Media
            resource={member.image}
            context={'card'}
            fill
            pictureClassName="size-full rounded-xl object-cover object-center"
            imgClassName="size-full rounded-xl object-cover object-center"
          />
        )}
        <div className="absolute inset-x-0 bottom-0 z-3 h-1/3 w-full bg-linear-to-b from-transparent to-black/50" />
      </div>
      {member.socialLinks?.some((social) => social.url) && (
        <div className="absolute top-3 right-3 z-3 flex items-center gap-2">
          {member.socialLinks.map((social) =>
            social.url ? (
              <Button
                variant="icon"
                key={social.platform}
                asChild
                className="flex size-8 items-center justify-center rounded-full bg-neutral-200 p-0 hover:bg-neutral-300"
              >
                <a
                  href={social.url}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  aria-label={`${member.name} on ${social.platform}`}
                >
                  {social.platform === 'x' ? (
                    <Media
                      resource="/media/logo_x.svg"
                      alt="X"
                      width={16}
                      height={16}
                      htmlelement={null}
                      pictureClassName="block size-3"
                      imgClassName="size-3"
                    />
                  ) : (
                    <DynamicIcon name={social.platform} className="size-4 text-foreground" />
                  )}
                </a>
              </Button>
            ) : null,
          )}
        </div>
      )}
      <div className="relative z-2 px-4 py-3">
        <div className="flex w-full items-end justify-between gap-4">
          <div className="min-w-0">
            <h2 className="truncate font-family-body text-base font-medium text-white">
              {member.name}
            </h2>
            <p className="truncate font-family-body text-base text-neutral-200">
              {member.jobTitle}
            </p>
          </div>
          <Button
            variant="link"
            color="inverse"
            className="shrink-0"
            onClick={(e) => {
              e.stopPropagation()
              onClick(member)
            }}
          >
            Read more<span className="sr-only">{` about ${member.name}`}</span>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default TeamMemberCard
